import L from "leaflet";
import boatIcon from "./images/features/boat.png";
import campIcon from "./images/features/camp.png";
import campingIcon from "./images/features/camping.png";
import certifiedIcon from "./images/features/certified.png";
import gearIcon from "./images/features/gear.png";
import guideIcon from "./images/features/guide.png";
import parkingIcon from "./images/features/Parking_icon.png";
import spotHigh from "./images/features/newFishGreen.png";
import spotLow from "./images/features/newFishGray.png";
import spotMedium from "./images/features/newFishLightGreen.png";
import summerhouseIcon from "./images/features/summerhouse.png";
import touristIcon from "./images/visitLogo.png";
import videoIcon from "./images/features/areaVideo.png";
import yourLoc from "./images/features/yourLoc.png";

const smallSize = 40;

let iconCamping = L.icon({
  iconUrl: campingIcon,
  iconSize: [smallSize, smallSize],
  iconAnchor: [20, 20],
});

let iconSummerhouse = L.icon({
  iconUrl: summerhouseIcon,
  iconSize: [smallSize, smallSize],
  iconAnchor: [20, 20],
});

let iconHighBig = L.icon({
  iconUrl: spotHigh,
  iconSize: [48, 48],
  iconAnchor: [32, 32],
});

let iconHighSmall = L.icon({
  iconUrl: spotHigh,
  iconSize: [smallSize, smallSize],
  iconAnchor: [20, 20],
});

let iconMedium = L.icon({
  iconUrl: spotMedium,
  iconSize: [smallSize, smallSize],
  iconAnchor: [20, 20],
});

let iconLowBig = L.icon({
  iconUrl: spotLow,
  iconSize: [48, 48],
  iconAnchor: [32, 32],
});

let iconLowSmall = L.icon({
  iconUrl: spotLow,
  iconSize: [smallSize, smallSize],
  iconAnchor: [20, 20],
});

let gear = L.icon({
  iconUrl: gearIcon,
  iconSize: [smallSize, smallSize],
});

let certified = L.icon({
  iconUrl: certifiedIcon,
  iconSize: [smallSize, smallSize],
});

let boat = L.icon({
  iconUrl: boatIcon,
  iconSize: [smallSize, smallSize],
});

let camp = L.icon({
  iconUrl: campIcon,
  iconSize: [smallSize, smallSize],
});

let location = L.icon({
  iconUrl: yourLoc,
  iconSize: [24, 24],
});

let parking = L.icon({
  iconUrl: parkingIcon,
  iconSize: [28, 28],
});

let tourist = L.icon({
  iconUrl: touristIcon,
  iconSize: [32, 32],
});

const guide = L.icon({
  iconUrl: guideIcon,
  iconSize: [smallSize, smallSize],
});

const video = L.icon({
  iconUrl: videoIcon,
  iconSize: [smallSize, smallSize],
});

export {
  iconHighBig,
  iconHighSmall,
  iconLowBig,
  iconLowSmall,
  iconMedium,
  camp,
  location,
  parking,
  tourist,
  boat,
  gear,
  certified,
  guide,
  video,
  iconCamping,
  iconSummerhouse,
};
